import { FC } from 'react';
import { ReleaseAndDeployments } from '@agilelab/plugin-wb-builder-common';
import { Box, useTheme } from '@material-ui/core';
import {
  useTruncatedStyles,
  WbInfoTooltip,
  WbLink,
} from '@agilelab/plugin-wb-platform';
import { BookmarkIcon } from './icons/BookmarkIcon';
import { useRouteRef } from '@mainstage/core-plugin-api';
import { releaseDetailRouteRef } from '../../../routes';
import { getReleaseInfo } from '../../../utils';

interface Props {
  release: ReleaseAndDeployments;
}

export const ReleaseName: FC<Props> = ({ release }) => {
  const theme = useTheme();
  const { truncated } = useTruncatedStyles({ maxLines: 1 });
  const name = `v${release.metadata.version}`;

  const releaseDetailRoute = useRouteRef(releaseDetailRouteRef);

  const link = releaseDetailRoute(getReleaseInfo(release));

  return (
    <Box display="flex" alignItems="center" style={{ gap: '8px' }}>
      {release.metadata.isSnapshot && (
        <WbInfoTooltip
          title="This is a draft release"
          icon={
            <BookmarkIcon
              fontSize="small"
              style={{ color: theme.palette.accent.main }}
            />
          }
        />
      )}
      <WbLink to={link} className={truncated}>
        {name}
      </WbLink>
    </Box>
  );
};
